export default "__VITE_ASSET__ReS5wW_k__"